@if (isMobile) {
  <app-inventario-digitacao-mobile [host]="this"></app-inventario-digitacao-mobile>
} @else {
<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">

    <!-- Título + voltar -->
    <div class="title-wrapper">
      <div>
        <h1 class="title-default">Inventário</h1>
        <p class="welcome-message">
          <button mat-icon-button (click)="voltarComConfirmacao()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Ajustar saldo de estoque do dia
        </p>
      </div>
    </div>

    @if (_isLoading) {
      <div class="loading-center">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else {

      @if (idStatusInventario === _StatusInventarioEnum.Falha && mensagemProcessamento) {
        <div class="mb-3">
          <app-alert-card type="error" title="Falha no processamento">
            {{ mensagemProcessamento }}
          </app-alert-card>
        </div>
      }

      <!-- Cabeçalho do inventário -->
      <form [formGroup]="formInventario">
        <div class="row g-3">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descrição</mat-label>
              <input matInput #descricaoInput formControlName="descricao" placeholder="Ex.: Balanço" required />
              @if (formInventario.get('descricao')?.hasError('required')) {
                <mat-error>Descrição é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Local de estoque</mat-label>
              <mat-select #localizacoesSelect formControlName="idsLocalizacoes" multiple required>
                @for (loc of listaLocalizacoes; track loc.id) {
                  <mat-option [value]="loc.id">{{ loc.descricao }}</mat-option>
                }
              </mat-select>
              @if (formInventario.get('idsLocalizacoes')?.hasError('required')) {
                <mat-error>Selecione ao menos uma localização</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Responsável</mat-label>
              <mat-select formControlName="idUsuarioResponsavel" required>
                @for (u of listaUsuarios; track u.idUsuario) {
                  <mat-option [value]="u.idUsuario">{{ u.nomeUsuario }}</mat-option>
                }
              </mat-select>
              @if (formInventario.get('idUsuarioResponsavel')?.hasError('required')) {
                <mat-error>Selecione o responsável</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data do inventário</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="dataInventario"
                (input)="onDateInput($event)"
                (keydown)="onDateKeydown($event)"
                (blur)="onDataInventarioBlur($event)"
                placeholder="DD/MM/AAAA"
                inputmode="numeric"
                maxlength="10"
                [max]="hoje"
                required />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Motivo do inventário</mat-label>
              <textarea matInput rows="3" formControlName="motivo"
                        placeholder="Justifique o inventário (opcional)"></textarea>
            </mat-form-field>
          </div>

        </div>
      </form>

      <!-- Filtro + Adicionar produto (mesma linha no desktop, empilhados no mobile) -->
      @if (!isReadOnly || itens.length > 0) {
        <div class="produtos-toolbar">
          @if (itens.length > 0) {
            <mat-form-field appearance="outline" class="produtos-toolbar__filtro" subscriptSizing="dynamic">
              <mat-icon matPrefix>search</mat-icon>
              <mat-label>Filtrar produtos</mat-label>
              <input matInput [(ngModel)]="filtroProduto" placeholder="Buscar por nome ou SKU..." />
              @if (filtroProduto) {
                <button matSuffix mat-icon-button (click)="filtroProduto = ''">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          }
          @if (!isReadOnly) {
            <button mat-button class="btn-section" (click)="adicionarProduto()">
              <mat-icon>add</mat-icon>
              Adicionar produto
            </button>
          }
        </div>
      }

      <!-- Grid de produtos -->
      @if (itens.length === 0) {
        <div class="empty-state-grid">Nenhum produto adicionado. Clique em + Adicionar produto para começar a digitar o inventário.</div>
      } @else {
        <div class="table-responsive">
          <table mat-table [dataSource]="linhasGridFiltradas" class="mat-elevation-z0 tabela-digitacao">

            <ng-container matColumnDef="produto">
              <th mat-header-cell *matHeaderCellDef>Produto</th>
              <td mat-cell *matCellDef="let row" [class.cell-sub]="row.tipo === 'sub'">
                @if (row.tipo === 'parent') {
                  @if (isReadOnly) {
                    <span class="produto-nome">{{ row.produto.nome }}</span>
                  } @else {
                    <app-select-pesquisavel [control]="row.produto.produtoControl" [apiUrl]="urlProduto"
                      [extraParams]="{ apenasControlaEstoque: true }"
                      [hideLabel]="true" placeholder="Produto"
                      idField="idProduto" nameField="descricao" [preloadedOptions]="row.produto.produtoPreload"
                      (selectionChange)="onProdutoTrocadoInventario(row.produto, $event)" [subscriptSizing]="'dynamic'">
                    </app-select-pesquisavel>
                  }
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="sku">
              <th mat-header-cell *matHeaderCellDef>SKU</th>
              <td mat-cell *matCellDef="let row" [class.cell-sub]="row.tipo === 'sub'">
                @if (row.tipo === 'parent') {
                  {{ row.produto.sku || '—' }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="unidade">
              <th mat-header-cell *matHeaderCellDef>Unidade</th>
              <td mat-cell *matCellDef="let row" [class.cell-sub]="row.tipo === 'sub'">
                @if (row.tipo === 'parent') {
                  {{ row.produto.unidade }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="local">
              <th mat-header-cell *matHeaderCellDef>Local de estoque</th>
              <td mat-cell *matCellDef="let row">
                @if (row.tipo === 'parent') {
                  @if (row.produto.locais.length === 1) {
                    {{ row.produto.locais[0].nomeLocalizacao }}
                  } @else if (row.produto.locais.length > 1) {
                    <span class="badge-multi-locais">{{ row.produto.locais.length }} Locais</span>
                  }
                } @else {
                  <span class="loc-sub">{{ row.local.nomeLocalizacao }}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="quantidade">
              <th mat-header-cell *matHeaderCellDef>Quantidade inventariada</th>
              <td mat-cell *matCellDef="let row">
                @if (row.tipo === 'parent' && row.produto.locais.length > 1) {
                  <span class="qtd-total">{{ somaQuantidades(row.produto) | abnt:'quantidade' }}</span>
                } @else if (row.local) {
                  <div class="qtd-input-wrap">
                    @if (row.produto.isControlaSeries) {
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-qtd-inline">
                        <input matInput type="text" readonly
                               [ngModel]="row.local.quantidadeInventariada ?? 0"
                               [ngModelOptions]="{ standalone: true }"
                               [currencyMask]="quantidadeMask" />
                      </mat-form-field>
                      <span class="rastreabilidade-wrap"
                            [matTooltip]="row.local.confirmadoRastreabilidade ? 'Séries confirmadas' : 'Séries pendentes de confirmação'">
                        <button mat-icon-button
                                (click)="abrirSerieModalOffline(row.produto, row.local)">
                          <mat-icon class="material-symbols-outlined">data_info_alert</mat-icon>
                        </button>
                        <span class="point-badge"
                              [class.point-badge--verde]="row.local.confirmadoRastreabilidade"
                              [class.point-badge--amarelo]="!row.local.confirmadoRastreabilidade"></span>
                      </span>
                    } @else if (row.produto.isControlaLotes) {
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-qtd-inline">
                        <input matInput type="text" readonly
                               [ngModel]="row.local.quantidadeInventariada ?? 0"
                               [ngModelOptions]="{ standalone: true }"
                               [currencyMask]="quantidadeMask" />
                      </mat-form-field>
                      <span class="rastreabilidade-wrap"
                            [matTooltip]="row.local.confirmadoRastreabilidade ? 'Lotes confirmados' : 'Lotes pendentes de confirmação'">
                        <button mat-icon-button
                                (click)="abrirLoteModalOffline(row.produto, row.local)">
                          <mat-icon class="material-symbols-outlined">data_info_alert</mat-icon>
                        </button>
                        <span class="point-badge"
                              [class.point-badge--verde]="row.local.confirmadoRastreabilidade"
                              [class.point-badge--amarelo]="!row.local.confirmadoRastreabilidade"></span>
                      </span>
                    } @else {
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-qtd-inline">
                        <input matInput type="text" inputmode="decimal"
                               [ngModel]="row.local.quantidadeInventariada"
                               [ngModelOptions]="{ standalone: true }"
                               [currencyMask]="quantidadeMask"
                               [readonly]="isReadOnly"
                               (ngModelChange)="onQuantidadeChange(row.local, $event)"
                               placeholder="0,00" />
                      </mat-form-field>
                      @if (ajuste(row.local) != null) {
                        <span class="ajuste-inline" [ngClass]="getAjusteClass(ajuste(row.local))">
                          {{ ajuste(row.local)! > 0 ? '+' : '' }}{{ ajuste(row.local) | abnt:'quantidade' }}
                        </span>
                      }
                    }
                  </div>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
              <td mat-cell *matCellDef="let row" class="text-center w-actions">
                @if (row.tipo === 'parent' && !isReadOnly) {
                  <button mat-icon-button class="btn-remover" matTooltip="Remover produto"
                          (click)="removerProduto(row.idProduto)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  </button>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"
                [class.linha-parent]="row.tipo === 'parent'"
                [class.linha-sub]="row.tipo === 'sub'"></tr>
          </table>
        </div>
      }

    }

  </div>
</div>

@if (!isReadOnly) {
  <app-footer-action
    cancelarLabel="Cancelar"
    salvarLabel="Concluir inventário"
    [isLoadingSalvar]="isConcluindo"
    [isSalvarDisabled]="isSalvandoRascunho || isConcluindo"
    (cancelar)="cancelar()"
    (salvar)="concluirInventario()">
    <button mat-stroked-button class="btn-secondary"
            [disabled]="isSalvandoRascunho || isConcluindo"
            (click)="salvarRascunho()">
      @if (isSalvandoRascunho) {
        <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
      } @else {
        Salvar
      }
    </button>
  </app-footer-action>
}
}
